import { createFileRoute, redirect } from "@tanstack/react-router";

// Tautan lama: galeri sekarang bagian dari halaman acara.
export const Route = createFileRoute("/a_/$slug/gallery")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/a/$slug", params });
  },
});
